// extracted by mini-css-extract-plugin
export default {"sidebar":"SidebarSmall_sidebar__pveIV","sidebarActive":"SidebarSmall_sidebarActive__a3Jfu","showArrow":"SidebarSmall_showArrow__ZIWzn"};